import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ArrowBackBlue } from 'Images';
import { useState } from 'react';

export const ExpertReview = () => {
  const [isOpenMoreInfo, setIsOpenMoreInfo] = useState<boolean>(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);

  return (
    <Stack gap='20px'>
      <Typography variant='body6'>{dictionary.steps.step2.info1}</Typography>
      {isOpenMoreInfo && (
        <>
          <Stack>
            <Typography variant='body5'>
              {dictionary.steps.step2.info2title}
            </Typography>
            <Typography variant='body6'>
              {dictionary.steps.step2.info2}
            </Typography>
          </Stack>
          <Typography variant='body6'>
            {dictionary.steps.step2.info3}
          </Typography>
          <Typography variant='body6'>
            <strong>{dictionary.steps.step2.info4Title}</strong>
            {dictionary.steps.step2.info4}
          </Typography>
          <Stack>
            <Typography variant='body5'>
              {dictionary.steps.step2.info5title}
            </Typography>
            <Typography variant='body6'>
              {dictionary.steps.step2.info5[0]}
            </Typography>
            <Typography variant='body6'>
              {dictionary.steps.step2.info5[1]}
            </Typography>
            <Typography variant='body6'>
              <strong>{dictionary.steps.step2.info5[2]}</strong>
              {dictionary.steps.step2.info5[3]}
            </Typography>
          </Stack>
        </>
      )}
      <Stack
        direction='row'
        alignItems='center'
        columnGap='4px'
        sx={{ ':hover': { cursor: 'pointer', textDecoration: 'underline' } }}
        onClick={() => setIsOpenMoreInfo(!isOpenMoreInfo)}
      >
        <Typography variant='body3' color='primary.main'>
          {isOpenMoreInfo ? dictionary.collapse : dictionary.moreInfo}
        </Typography>
        <Avatar
          alt=''
          src={ArrowBackBlue}
          sx={{
            height: '16px',
            width: '16px',
            transform: isOpenMoreInfo ? 'rotate(90deg)' : 'rotate(-90deg)',
          }}
        />
      </Stack>
    </Stack>
  );
};
